import type { RawThemesListConfig } from 'entities/Config'

const getConfig = () => {
  const config = window?._saeConversationalConfig

  return config as RawThemesListConfig
}

export default getConfig
